<div class="small-only-text-center">
  <div
    class="panel rs-inline-block rs-wd-s6 rs-wd-m10 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
  ></div>
</div>
<div class="panel rs-bg-grey1 clearfix">
  <div class="rs-flex-row">
    <div class="rs-flex-columns small-12 medium-6">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-maxh rs-justify-right">
            <div class="rs-flex-column">
              <div
                class="panel rs-wd-s19 rs-wd-m26 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div class="rs-flex-row rs-flex-middle">
                <div class="rs-flex-columns rs-flex-grow">
                  <div
                    class="panel rs-wd-s8 rs-wd-m10 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="rs-flex-columns">
                  <div
                    class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-flex-columns small-12 medium-6">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-maxh rs-justify-right">
            <div class="rs-flex-column">
              <div
                class="panel rs-wd-s19 rs-wd-m26 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div class="rs-flex-row rs-flex-middle">
                <div class="rs-flex-columns rs-flex-grow">
                  <div
                    class="panel rs-wd-s8 rs-wd-m10 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="rs-flex-columns">
                  <div
                    class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
